import styled from "styled-components"
import { device } from "breakpoints"

export const InternalTitleBlockWrapper = styled.div`
  margin-bottom: 25px;
  @media ${device.tablet} {
    width: 30%;
    float: left;
  }

  h1 {
    font-size: 30px;
    color: #0000ff;
    letter-spacing: 0;
    line-height: 34px;

    @media ${device.desktop} {
      margin-bottom: 0px;
      font-size: 42px;
      line-height: 48px;
    }
  }
  > :first-child {
    margin-top: 0;
  }
`

export const TagsList = styled.ul`
  margin-left: 17px;
  display: none;
  margin-top: 25px;

  @media ${device.tablet} {
    display: block;
    margin-top: 15px;
    margin-bottom: 40px;
  }

  @media ${device.desktop} {
    margin-top: 25px;
    margin-left: 25px;
    margin-bottom: 60px;
  }

  li {
    font-weight: 500;
    font-size: 14px;
    color: #5a5a5a;
    letter-spacing: 0.44px;
    list-style-type: none;
    position: relative;
    margin-bottom: 4px;

    ::before {
      content: "";
      height: 8px;
      width: 8px;
      background-color: ${props => props.theme.green};
      display: block;
      border-radius: 50%;
      position: absolute;
      top: 5px;
      left: -17px;
      @media ${device.desktop} {
        left: -25px;
      }
    }
  }
`

export const NewsInfo = styled(TagsList)`
  display: block;
  margin-top: 10px;

  @media ${device.desktop} {
    margin-top: 10px;
  }

  li,
  span {
    font-size: 12px;
    margin-bottom: 0;
    @media ${device.desktop} {
      font-size: 14px;
      margin-bottom: 3px;
    }
  }

  span {
    display: block;
    font-weight: 300;
    color: #5a5a5a;
  }
`
